const PaymentMethodENGEnum = {
  BANK_TRANSFER: 'Bank transfer'
  };

export default PaymentMethodENGEnum;